export enum RouteNames {
  // Register
  Register = "register",
  Register_Mail = "mail",
  Register_SMS = "sms",
  Register_Reset = "reset",

  // Login
  Login = "login",
  Login_Reset = "reset",

  // Dashboard
  Dashboard = "dashboard",
  /** 報名 */
  Dashboard_Register = "register",
  /** Trivago */
  Dashboard_Hotel = "hotel",
  /** 真 . 活動 */
  Dashboard_Event = "event",
  /** 帳戶 */
  Dashboard_Account = "account",
  /** 毛裝扮演者 */
  Dashboard_Fursuiter = "fursuiter",
  /** After Party 報名 */
  Dashboard_AfterParty = "afterParty",
  /** Dealers Den 報名狀態 */
  Dashboard_DealersDen = "dealersDen",
  /** 夕陽浪漫愛情摩天船 */
  /** Dashboard_Boat = "boat", */
  /** 假活動 . 真表單 */
  /** Dashboard_Forms = 'forms', */

  /** 帳戶_帳戶 */
  Dashboard_Account_Account = "account",
  /** 帳戶_安全性 */
  Dashboard_Account_Security = "security",

  /** 獸裝_我的獸裝 */
  Dashboard_Fursuiter_MyFursuit = "myfursuit",
  /** 獸裝_毛毛更衣室 */
  Dashboard_Fursuiter_ChangeRoom = "changeroom",

  /** 集點 */
  Dashboard_Point = 'point',

  /** 活動 Redirect */
  Dashboard_ActivityRedirect = "activity/redirect",

  // 報名活動 (跟註冊不一樣！)
  RegisterEvent = "register_event",

  // Backend
  Backend = "backend",
  /** 操作紀錄 */
  Backend_AuditLog = "audit_log",
  /** 使用者 */
  Backend_Users = "users",
  /** 報名資料 */
  Backend_Registrations = "registrations",
  /** 現場報名 */
  Backend_RegistrationsOnsite = "registrationsonsite",
  /** After Party 報名 */
  Backend_AfterPartyTickets = "afterPartyTickets",
  /** 信箱黑名單 */
  Backend_EmailBlacklist = "email_blacklist",
  /** 電話黑名單 */
  Backend_PhoneBlacklist = "phone_blacklist",
  /** 群組 */
  Backend_Groups = "groups",
  /** 折扣代碼 */
  Backend_Coupon = "coupon",
  /** 獎品 */
  Backend_LotteryItem = "lottery_item",
  /** 報名等級 */
  Backend_Levels = "levels",
  /** 首頁 */
  Backend_Index = "index",
  Backend_LotteryResult = "lottery_result",
  /** 實驗性的RFID */
  Backend_RFID = "rfid",
  /** 特殊報名Token */
  Backend_RegistrationToken = "registration_token",
  /** 等級升級清單 */
  Backend_RegistrationUpgrades = "registration_upgrades",
  /** 功能實驗場 */
  Backend_Experiment = "experiment",
  /** 訂單查詢 */
  Backend_Order = "order",
  /** 飯店列表 */
  Backend_Hotel = "hotel",
  /** 房型列表 */
  Backend_Room = "room",
  /** 房型組合列表 */
  Backend_RoomType = "room_type",
  /** 問題列表 */
  Backend_Quiz = "quiz",
  /** 訂房紀錄 */
  Backend_Reservation = 'reservation',
  /** Hen危險的設定 */
  Backend_Config = 'config',
  /** 因為有錢 更危險的設定 */
  Backend_PaymentConfig = 'payment_config',
  /** 訂房紀錄 */
  Backend_ReservationFuron = 'reservationFuron',
  /** 表單撰寫器 */
  Backend_FormsBuilder = 'forms_builder',
  /** 表單回覆 */
  Backend_FormsResponses = 'forms_responses',

  /** 毛毛列表資訊 */
  Backend_FursuitFursuiters = 'fursuit_fursuiters',
  /** 毛毛標籤 */
  Backend_FursuitTags = 'fursuit_tags',
  /** 毛毛更衣室 */
  Backend_FursuitChangeRoom = 'fursuit_changeroom',

  /** ~~妖~~獸之船 */
  Backend_Boat = 'boat',
  /** ~~妖~~獸之船預約 */
  Backend_BoatReservation = 'boat_reservation',

  // 集點
  /** 使用者點數 */
  Backend_UserPoints = 'point_userpoints',
  Backend_Rewards = 'point_rewards',
  Backend_PointToken = 'point_token',
  Backend_PointHistory = 'point_history',

  /** 服務台 */
  Backend_FrontDeskPoint = 'frontdesk_point',
  Backend_FrontDeskPunchInOut = 'frontdesk_punchinout',
  Backend_FrontDeskCheckIn = 'frontdesk_checkin',
  Backend_FrontDeskSouvenir = 'frontdesk_souvenir',
  Backend_FrontDeskActivityCheckIn = 'frontdesk_activity_checkin',

  /** 讀卡機 */
  Backend_BadgeReader = 'badge_reader',
  Backend_CardRegistration = 'card_registration',

  // 活動
  Backend_ActivityActivities = 'activity_activities',
  Backend_ActivityArea = 'activity_area',
  Backend_ActivityParticipationHistory = 'activity_participation_history',
  Backend_ActivityStatus = 'activity_status',
  Backend_ActivityTask = 'activity_task',
  Backend_ActivityTaskReport = 'activity_taskreport',

  // 出勤 / 排班
  Backend_PunchPunches = 'punch_punches',
  Backend_PunchMakeups = 'punch_makeups',
  Backend_PunchSchedules = 'punch_schedules',

  // 志工頁
  Volunteer = 'volunteer',
  Volunteer_Punches = 'volunteer_punches',
  Volunteer_MakeUps = 'volunteer_makeups',
  Volunteer_PointToken = 'volunteer_pointtoken',
  /** 彩蛋ＡＡＡＡＡＡＡＡＡ */
  A = "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA",

  /**
   * ㄜ
   * ㄜㄜ
   * meow
   */
  Meow = "meow",


}
